import NoDataTableRow from './NoDataTableRow';

export default NoDataTableRow;
